import axios from "axios";

const host = typeof window !== "undefined" ? window.location : null;
export const BACKEND_URL = host && /^https?:$/.test(host.protocol) && !/^(localhost|127\.0\.0\.1)$/.test(host.hostname) ? host.origin : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const authedFileUrl = (path) => `${API}/files/${path}`;

export const isMobileDevice = () =>
  typeof navigator !== "undefined" && /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || "");


// Descarga/abre un PDF de forma compatible con móvil, iOS PWA y escritorio.
// Siempre se descarga el blob con petición AUTENTICADA (XHR con cookies), para no depender
// de que la cookie de sesión fluya en una pestaña nueva (falla en PWA/webview iOS/Android → 401).
// Se usa un ancla <a download> (escritorio/Android descargan; iOS abre el PDF en pestaña para ver/guardar).
export async function downloadPdf(path, { params = {}, filename = "documento.pdf" } = {}) {
  const r = await api.get(path, { params, responseType: "blob", timeout: 120000 });
  let blob = r.data;
  // Si el servidor respondió un error en JSON (aunque sea 200), detectarlo y avisar.
  if (blob && blob.type && blob.type.includes("application/json")) {
    let msg = "No se pudo generar el PDF.";
    try { msg = JSON.parse(await blob.text()).detail || msg; } catch { /* noop */ }
    throw new Error(msg);
  }
  blob = blob && blob.type ? blob : new Blob([blob], { type: "application/pdf" });
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  a.rel = "noopener";
  // iOS ignora 'download': abrir en nueva pestaña para que el usuario vea/guarde el PDF.
  if (isMobileDevice()) a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
}
